// extracted by mini-css-extract-plugin
var _1 = "wi6ZYFmuXfd5X1lzkG03";
var _2 = "MuHz7qFlLos0knfGgoQA";
var _3 = "tV1bAAoGkLHOdPzIOse5";
var _4 = "#000000";
var _5 = "#76F366";
var _6 = "#EB8632";
var _7 = "#ECC834";
var _8 = "#21FC87";
var _9 = "#EA4A30";
var _a = "#C7EA45";
var _b = "#272B2B";
var _c = "#BDBDBD";
var _d = "#7D7D7D";
var _e = "#6A0DAD";
var _f = "#3A65FF";
var _10 = "#4A90E2";
var _11 = "#ffffff";
var _12 = "yk2QeQjgzNTSUpElf6R7";
var _13 = "prHryblEiFw88oLYvmy_";
var _14 = "1200px";
var _15 = "992px";
var _16 = "1366px";
var _17 = "768px";
var _18 = "1475px";
var _19 = "576px";
var _1a = "1600px";
var _1b = "320px";
var _1c = "2500px";
var _1d = "nUFaXAqDcPCbvRcOwaQo";
var _1e = "vDc8ReFalqTRL7KukYC7";
export { _1 as "actions", _2 as "active-media-preview", _3 as "base-link", _4 as "colorBlack", _5 as "colorGradeEX", _6 as "colorGradeFR", _7 as "colorGradeGD", _8 as "colorGradeOU", _9 as "colorGradePR", _a as "colorGradeVG", _b as "colorNeutral", _c as "colorNeutralLighest", _d as "colorNeutralLight", _e as "colorNonOwnerSweetLine", _f as "colorOwnerSweetLine", _10 as "colorRegularLinks", _11 as "colorWhite", _12 as "reset-button", _13 as "restIcons", _14 as "screenlg", _15 as "screenmd", _16 as "screenml", _17 as "screensm", _18 as "screenxlg", _19 as "screenxs", _1a as "screenxxlg", _1b as "screenxxs", _1c as "screenxxxlg", _1d as "single-page-responsive-font-size", _1e as "socialAction" }
export default { "actions": _1, "active-media-preview": _2, "base-link": _3, "colorBlack": _4, "colorGradeEX": _5, "colorGradeFR": _6, "colorGradeGD": _7, "colorGradeOU": _8, "colorGradePR": _9, "colorGradeVG": _a, "colorNeutral": _b, "colorNeutralLighest": _c, "colorNeutralLight": _d, "colorNonOwnerSweetLine": _e, "colorOwnerSweetLine": _f, "colorRegularLinks": _10, "colorWhite": _11, "reset-button": _12, "restIcons": _13, "screenlg": _14, "screenmd": _15, "screenml": _16, "screensm": _17, "screenxlg": _18, "screenxs": _19, "screenxxlg": _1a, "screenxxs": _1b, "screenxxxlg": _1c, "single-page-responsive-font-size": _1d, "socialAction": _1e }
